'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/common/overlay/dialog/dialog';
import PricingPlans from '@/components/features/core/billing/PricingPlans';
import { useI18n } from '@/locales/client';

interface PaywallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaywallModal = ({ isOpen, onClose }: PaywallModalProps) => {
  const t = useI18n();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='max-w-4xl overflow-y-auto max-h-[90vh] sm:max-w-[900px]'>
        <div className='flex flex-col gap-4 text-center'>
            <DialogTitle className='text-2xl font-bold text-[#384250]'>
              {t('upgrade.limitReached.title')}
            </DialogTitle>
            <DialogDescription className='text-gray-600'>
              {t('upgrade.limitReached.description')}
            </DialogDescription>
        </div>

        <div className='mt-4'>
            <PricingPlans onClose={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
